module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('title', [_vm._v("Believing Jesus: Are You Willing to Risk Everything?: A Journey Through the Book of Acts")]), _c('link', {
    attrs: {
      "href": "css/default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ct",
    attrs: {
      "id": "pz11-1"
    }
  }, [_c('i', [_vm._v("Contents")]), _c('a', {
    attrs: {
      "id": "AEE"
    }
  })]), _c('a', {
    attrs: {
      "id": "AEE"
    }
  }), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pA98"
    }
  }, [_c('a', {
    attrs: {
      "id": "AEE"
    }
  }), _c('a', {
    attrs: {
      "href": "#/chapter02#toc2",
      "id": "con2"
    }
  }, [_c('b', [_vm._v("one:")]), _vm._v(" THE COST OF DISCIPLESHIP")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pAno"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter03#toc3",
      "id": "con3"
    }
  }, [_c('b', [_vm._v("two:")]), _vm._v(" EARTH, WIND, AND CELESTIAL FIRE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pAqg"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter04#toc4",
      "id": "con4",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("three:")]), _vm._v(" CHECKERED PASTS CAN MAKE INCREDIBLE PREACHERS")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pAKB"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter05#toc5",
      "id": "con5",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("four:")]), _vm._v(" WHAT’S MINE IS YOURS")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "pAmS"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter06#toc6",
      "id": "con6",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("five:")]), _vm._v(" LOVING MORE PEOPLE, MORE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "Ada"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter07#toc7",
      "id": "con7",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("six:")]), _vm._v(" SINNERS WHO WOULD BE SAINTS")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "AXG"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter08#toc8",
      "id": "con8",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("seven:")]), _vm._v(" A COMPASSIONATE COMPULSION")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "ArWR"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter09#toc9",
      "id": "con9",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("eight:")]), _vm._v(" THE NEED TO BE REGOSPELED")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "AgY"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter10#toc10",
      "id": "con10",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("nine:")]), _vm._v(" BEARING THE CHAIN BECAUSE")])]), _vm._v(" "), _c('p', {
    staticClass: "cct",
    attrs: {
      "id": "A1u"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter11#toc11",
      "id": "con11",
      "title": "Link target outside of Sample"
    }
  }, [_c('b', [_vm._v("ten:")]), _vm._v(" KICKING SAFE, COMFORTABLE CHRISTIANITY TO THE CURB")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "pz11-3"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter12#toc12",
      "id": "con12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("NOTES")])]), _vm._v(" "), _c('p', {
    staticClass: "cct1",
    staticStyle: {
      "text-indent": "0"
    },
    attrs: {
      "id": "pz11-4"
    }
  }, [_c('span', {
    attrs: {
      "href": "#/chapter13#toc13",
      "id": "con13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("ABOUT THE AUTHOR")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0faf4820","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/contents.vue
// module id = 69
// module chunks = 0